// extracted by mini-css-extract-plugin
export default {"tx":"_2a5d440159","line":"_6299c10e44"};